<template>
  <div>
    <HMFilePreview :file="video" />
  </div>
</template>

<script>
import HMFilePreview from '@/web/components/common/HMFilePreview';
export default {
  name: 'HMVideoModal',
  components: { HMFilePreview },
  props: {
    video: {
      type: Object,
    },
  },
};
</script>

<style></style>
